import React from "react";
import { Divider } from "antd";
import moment from "moment";
import "moment/locale/es";
import ModalItem from "../../../Components/ModalItem";
import ButtonItem from "../../../Components/ButtonItem";

moment.locale("es");

/**
 * Se muestra al entrar al panel cuando hay posts de Blog marcados como
 * aviso (esAviso=true) que el usuario todavía no ha visto. Al cerrarlo
 * se marcan como vistos en el backend, así que no vuelven a aparecer.
 */
const ModalAvisosBlog = ({ visible, avisos = [], onCerrar }) => {
  const varios = avisos.length > 1;

  return (
    <ModalItem
      visible={visible}
      title={varios ? `${avisos.length} avisos nuevos` : "Nuevo aviso"}
      onCancel={onCerrar}
      footer={null}
      destroyOnClose
      width={700}
    >
      <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 4 }}>
        {avisos.map((aviso, index) => (
          <div key={aviso._id}>
            {aviso.imagenUrl && (
              <img
                src={aviso.imagenUrl}
                alt={aviso.titulo}
                style={{
                  width: "100%",
                  maxHeight: 320,
                  objectFit: "cover",
                  borderRadius: 8,
                  marginBottom: 16,
                }}
              />
            )}
            <h2 style={{ marginBottom: 4 }}>{aviso.titulo}</h2>
            {aviso.fecha && (
              <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 12 }}>
                {moment(aviso.fecha).format("LL")}
              </div>
            )}
            <div
              style={{ fontSize: 15, lineHeight: 1.8, whiteSpace: "pre-wrap" }}
              dangerouslySetInnerHTML={{ __html: aviso.contenido }}
            />
            {index < avisos.length - 1 && <Divider />}
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <ButtonItem type="primary" onClick={onCerrar}>
          Entendido
        </ButtonItem>
      </div>
    </ModalItem>
  );
};

export default ModalAvisosBlog;
